import { IPatrimonialDependenceContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const PatrimonialDependenceContext = createContext<IPatrimonialDependenceContextData>({} as IPatrimonialDependenceContextData);
